<template>
  <div class='h-dialogContainer'>
    <BaseBusiness :formParam='item' :ref='item.name' :defaultData='msg'></BaseBusiness>
    <div class='h-clear-rowMg'></div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import BaseBusiness from './BaseBusiness';
import { EventBus } from '../../../plugins/eventBus';

const { mapGetters } = createNamespacedHelpers('trackConfig');
export default {
  name: 'trackDetail',
  components: {
    BaseBusiness
  },
  data() {
    return {
      locale: localStorage.getItem('locale'),
      dateFormat: 'yyyy-MM-dd hh:mm:ss',
      item: {
        name: ''
      },
      msg: {},
      alarmData: {
        alarmID: '29972',
        levelStr: 'CRITICAL'
      }
    };
  },
  computed: {
    ...mapGetters(['neVisionList']),
  },
  methods: {
    setTrackId(msg) {
      try {
        // 判断缓存中是否有对应neId的数据
        // 根据msg.neId来查询，查询后放入对应neId的缓存
        let formDatas = JSON.parse(localStorage.getItem('trackForms'));
        if (!formDatas) {
          formDatas = {};
        }
        const formData = formDatas[`${this.neVisionList[msg.neId][0]}${this.neVisionList[msg.neId][1]}${this.locale}`];
        if (formDatas && formData && formData[msg.typeId]) {
          this.item = formData[msg.typeId];
        } else {
          this.$axios.get(`/lte/ems/track/queryFormConfig?version=${this.neVisionList[msg.neId][0]}&neType=${this.neVisionList[msg.neId][1]}`).then((response) => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              const result = response.data.resultVal;
              this.item = result.find(data => data.typeID === msg.typeId);
              result.forEach(form => {
                if (!formDatas[`${this.neVisionList[msg.neId][0]}${this.neVisionList[msg.neId][1]}${this.locale}`]) {
                  formDatas[`${this.neVisionList[msg.neId][0]}${this.neVisionList[msg.neId][1]}${this.locale}`] = {};
                }
                formDatas[`${this.neVisionList[msg.neId][0]}${this.neVisionList[msg.neId][1]}${this.locale}`][form.typeID] = form;
              });
              localStorage.setItem('trackForms', JSON.stringify(formDatas));
            } else {
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
      this.msg = msg;
    }
  }
};
</script>
